import * as React from "react";
import "./ProgressBar.css";



interface IProps {
    progressPages: any[];
    currentPage: any;
    isSBAForm: boolean
}

export default class ProgressBar  extends React.Component<
    IProps
    > {


    public renderProgressBar = () => {
        const {progressPages, currentPage, isSBAForm} = this.props;
        const currentPageIndex = progressPages.indexOf(currentPage);
        const progress = progressPages.map((page, index) => {
            let classes = index <= currentPageIndex ? "progress-step full" : "progress-step empty";
            classes +=  index <= currentPageIndex && isSBAForm? " sba": "";
            classes += index === currentPageIndex? " last" : "";
            return <div key={index} className={classes} style={{width: (1 / progressPages.length) * 100 + "%"}}/>

        });
        return progress;
    };

    public render() {
        const {currentPage, progressPages} = this.props;
        return progressPages.indexOf(currentPage) > -1 ?
            <div className="progress-bar">
                {this.renderProgressBar()}
            </div> : null;
    }
}


// WEBPACK FOOTER //
// ./src/components/ProgressBar/ProgressBar.tsx